import React from 'react';
import HeaderOne from '../../common/header/HeaderOne';
import BreadcrumbOne from '../../common/breadcrumb/BreadcrumbOne';
import PracticeFullWidthSectionOne from '../../components/practice-components/PracticeFullWidthSectionOne';
import FooterOne from '../../common/footer/FooterOne';

const PracticeFullWidthOne = () => {
    return (
        <>
        <HeaderOne />

        <BreadcrumbOne 
            title="Practice Full Width 1"
            rootUrl="/"
            parentUrl="Home"
            currentUrl="Practice Full Width 1"
        />
        
        <PracticeFullWidthSectionOne />
        
        <FooterOne />
        </>
    )
}
    
export default PracticeFullWidthOne;